<template>
    <button :class="[showImage ? 'show-image' : '', small ? 'small' : '', gradient ? 'gradient' : '']" @click="showImage = !showImage ; $emit('click')">
        <svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient x1="100%" y1="50%" x2="-2.22044605e-14%" y2="50%" id="linearGradient-gradient">
                    <stop stop-color="#F5831F" offset="0%"></stop>
                    <stop stop-color="#FED208" offset="100%"></stop>
                </linearGradient>
            </defs>
            <path d="M15.277 17L17 15.277 10.223 8.5 17 1.723 15.277 0 8.5 6.777 1.723 0 0 1.723 6.777 8.5 0 15.277 1.723 17 8.5 10.223z" fill="#fff" fill-rule="nonzero"/>
        </svg>        
    </button>
</template>

<script>
export default {
  name: "ShowImage",  
  props: {
      small: {
          default:false,
          type:Boolean
      },
      gradient: {
          default:false,
          type:Boolean
      },
      showImage: {
          default:false,
          type:Boolean
      }
  },
  data: () => ({
  }),
};
</script>


<style lang="scss" scoped>
button {
    position: absolute;
    right:20px;
    top:20px;
    z-index: 1;
    width:45px;
    height:45px;
    background-color: rgba(#0B0B0B, 0.7);
    border:none;
    display: inline-flex;
    align-items:center;
    justify-content: center;
    border-radius: 100%;
    overflow: hidden;
    outline:none;
    cursor: pointer;
    &.small {
        width:30px;
        height:30px;
    }
    &.gradient svg path {
            transition:fill 0.4s 0.2s cubic-bezier(0.075, 0.82, 0.165, 1); 
            fill: url('#linearGradient-gradient');
    }
    &:before {
        position: absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background-image: linear-gradient(269deg, #f5831f 0%, #fed208 100%);
        opacity: 0;
        transition:opacity 0.4s 0.2s cubic-bezier(0.075, 0.82, 0.165, 1); 
        content:" ";
    }
    svg {
        width:11px;
        height:11px;
        display: inline-block;
        transition: transform 0.5s;
        transform: rotateZ(45deg);
    }
    &:hover {
        &:before {
            opacity: 1;
        }        
    }
    &.show-image svg {
        transform: rotateZ(0);
    }
}
</style>
